// extracted by mini-css-extract-plugin
module.exports = {"form":"edit_cart_item_form_form__ixKRP","input":"edit_cart_item_form_input__4jCja"};